import React, { useEffect } from "react";
import { Box } from "@mui/material";
import HeroSection from "./sections/HeroSection";
import ServicesSection from "./sections/ServicesSection";
import ProcessSection from "./sections/ProcessSection";

const VizapPage = () => {
  // ── Clarity Event Tracking ──────────────────────────────────────────────
  useEffect(() => {
    const handleClick = (e) => {
      if (typeof window.clarity !== 'function') return;

      const btn = e.target.closest('button');
      if (!btn) return;
      const text = btn.innerText?.trim().toLowerCase() || '';

      // Try Now — Primary CTA for Viz App
      if (text.includes('try now')) {
        window.clarity('set', 'cta_clicked', 'viz_try_now');
        window.clarity('event', 'viz_try_now_clicked');
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);
  // ────────────────────────────────────────────────────────────────────────

  const backgroundSvgPath = "/images/smartReportingNew/job297-ploy-07c-blue-01.svg";

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#ffffff",
        backgroundImage: `url(${backgroundSvgPath})`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "scroll",
      }}
    >
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
        }}
      >
        {/* Hero Section */}
        <HeroSection />

        {/* Services Section */}
        <ServicesSection />

        {/* Process Section */}
        <ProcessSection />
      </Box>
    </Box>
  );
};

export default VizapPage;